import React from "react";

// Components
import TextInput from "components/input/TextInput";
import Spinner from "assets/icons/general/Spinner";

function AssessmentValidation({
  queryParamsEmail,
  queryParamsAssessmentId,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isValidating,
}) {
  return (
    <div className="bg-gray-100 rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6">
      <TextInput
        name="assessment_uuid"
        label="Evaluation ID"
        required={true}
        placeholder="Fill in your evaluation ID..."
        onChange={handleChange}
        onBlur={handleBlur}
        error={
          errors?.assessment_uuid &&
          touched?.assessment_uuid &&
          errors.assessment_uuid
        }
        value={values.assessment_uuid}
        capitalize={false}
        disabled={!queryParamsAssessmentId || queryParamsAssessmentId === ""}
      />
      <TextInput
        name="assessment_email_address"
        label="Evaluation Email Address"
        required={true}
        placeholder="Fill in your evaluation email address..."
        onChange={handleChange}
        onBlur={handleBlur}
        error={
          errors?.assessment_email_address &&
          touched?.assessment_email_address &&
          errors.assessment_email_address
        }
        value={values.assessment_email_address}
        capitalize={false}
        disabled={!queryParamsEmail || queryParamsEmail === ""}
      />
      <div>
        <button
          className="uppercase tracking-widest bg-black text-white w-full p-2 rounded-xl text-lg xl:text-2xl font-semibold disabled:opacity-30"
          onClick={handleSubmit}
          disabled={
            isValidating || !queryParamsAssessmentId || !queryParamsEmail
          }
          type="submit"
        >
          {isValidating && <Spinner />}
          Validate Evaluation
        </button>
      </div>
    </div>
  );
}

export default AssessmentValidation;
